<template>
  <div>
    <b-container fluid>
        <b-row>
          <b-col class="text-style"
            ><b-link class="item-highlight" @click="exportCountResult">Export Count Result</b-link>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <table class="table b-table table-striped table-hover">
              <thead role="rowgroup">
                <tr>
                  <td
                    valign="middle"
                    align="center"
                    rowspan="2"
                    class="tablehead"
                    style=""
                  >
                    Geographies
                  </td>
                  <td colspan="2" align="center" class="tablehead">Homes</td>
                  <td colspan="2" align="center" class="tablehead">Apts</td>
                  <td colspan="2" align="center" class="tablehead">Business</td>
                  <td colspan="2" align="center" class="tablehead">Total</td>
                  <td
                    valign="middle"
                    align="center"
                    colspan="4"
                    class="tablehead"
                    style=""
                  >
                    Median
                  </td>
                </tr>
                <tr role="row">
                  <td
                    align="center"
                    class="sorthead"
                    @click="sortClick('AvailableQtyHome')"
                    :aria-sort="sortFild === 'AvailableQtyHome' ? sort : 'none'"
                  >
                    Avail.
                  </td>
                  <td
                    align="center"
                    class="sorthead"
                    @click="sortClick('DesiredQtyHome')"
                    :aria-sort="sortFild === 'DesiredQtyHome' ? sort : 'none'"
                  >
                    Qty
                  </td>
                  <td
                    align="center"
                    class="sorthead"
                    @click="sortClick('AvailableQtyApt')"
                    :aria-sort="sortFild === 'AvailableQtyApt' ? sort : 'none'"
                  >
                    Avail.
                  </td>
                  <td
                    align="center"
                    class="sorthead"
                    @click="sortClick('DesiredQtyApt')"
                    :aria-sort="sortFild === 'DesiredQtyApt' ? sort : 'none'"
                  >
                    Qty
                  </td>
                  <td
                    align="center"
                    class="sorthead"
                    @click="sortClick('AvailableQtyBuss')"
                    :aria-sort="sortFild === 'AvailableQtyBuss' ? sort : 'none'"
                  >
                    Avail.
                  </td>
                  <td
                    align="center"
                    class="sorthead"
                    @click="sortClick('DesiredQtyBuss')"
                    :aria-sort="sortFild === 'DesiredQtyBuss' ? sort : 'none'"
                  >
                    Qty
                  </td>
                  <td
                    align="center"
                    class="sorthead"
                    @click="sortClick('AvailableQty')"
                    :aria-sort="sortFild === 'AvailableQty' ? sort : 'none'"
                  >
                    Avail.
                  </td>
                  <td
                    align="center"
                    class="sorthead"
                    @click="sortClick('DesiredQty')"
                    :aria-sort="sortFild === 'DesiredQty' ? sort : 'none'"
                  >
                    Qty
                  </td>
                  <td
                    align="center"
                    class="sorthead"
                    @click="sortClick('Income')"
                    :aria-sort="sortFild === 'Income' ? sort : 'none'"
                  >
                    Income
                  </td>
                  <td
                    align="center"
                    class="sorthead"
                    @click="sortClick('HomeValue')"
                    :aria-sort="sortFild === 'HomeValue' ? sort : 'none'"
                  >
                    Home Value
                  </td>
                  <td
                    align="center"
                    class="sorthead"
                    @click="sortClick('MedianAge')"
                    :aria-sort="sortFild === 'MedianAge' ? sort : 'none'"
                  >
                    Age
                  </td>
                  <td
                    align="center"
                    class="sorthead"
                    @click="sortClick('PHWC')"
                    :aria-sort="sortFild === 'PHWC' ? sort : 'none'"
                  >
                    PHWC
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr id="results_occu_total_row">
                  <td align="left" width="15%"><strong>Total</strong></td>
                  <td align="center" width="6%"></td>
                  <td align="left" width="10%">{{ order.DesiredQtyHome }}</td>
                  <td align="center" width="6%"></td>
                  <td align="left" width="10%">{{ order.DesiredQtyApt }}</td>
                  <td align="center" width="6%"></td>
                  <td align="left" width="10%">{{ order.DesiredQtyBuss }}</td>
                  <td align="center" width="6%">
                    {{ order.TotalAvailableQty }}
                  </td>
                  <td align="left" width="10%">
                    {{ order.TotalDesiredQty }}
                  </td>
                  <td align="center" width="6%"></td>
                  <td align="center" width="9%"></td>
                  <td align="center" width="5%"></td>
                  <td align="center" width="5%"></td>
                </tr>
                <template v-for="(item, index) in geos">
                  <tr>
                    <td align="left" @click="tiggerShow(index)">
                      <icon
                        v-show="item.showDetail !== true"
                        name="plus-circle"
                        class="h3-icon"
                      />
                      <icon
                        v-show="item.showDetail === true"
                        name="minus-circle"
                        class="h3-icon"
                      />{{ item.GeoKeyDesc }}
                    </td>
                    <td align="center">
                      <span>{{ item.AvailableQtyHome }}</span>
                    </td>
                    <td align="left">
                      <input
                        type="checkbox"
                        @change="changeGeoCount('homes', index, $event)"
                        :checked="item.DesiredQtyHome !== 0"
                        :disabled="item.AvailableQtyHome === 0"
                      />
                      {{ item.DesiredQtyHome }}
                    </td>
                    <td align="center">
                      {{ item.AvailableQtyApt }}
                    </td>
                    <td align="left">
                      <input
                        type="checkbox"
                        @change="changeGeoCount('apts', index, $event)"
                        :checked="item.DesiredQtyApt !== 0"
                        :disabled="item.AvailableQtyApt === 0"
                      />
                      {{ item.DesiredQtyApt }}
                    </td>
                    <td align="center">
                      <span>{{ item.AvailableQtyBuss }}</span>
                    </td>
                    <td align="left">
                      <input
                        type="checkbox"
                        @change="changeGeoCount('business', index, $event)"
                        :checked="item.DesiredQtyBuss !== 0"
                        :disabled="item.AvailableQtyBuss === 0"
                      />
                      {{ item.DesiredQtyBuss }}
                    </td>
                    <td align="center">
                      <span>{{ item.AvailableQty }}</span>
                    </td>
                    <td align="left">
                      <input
                        type="checkbox"
                        @change="changeGeoCount('total', index, $event)"
                        :checked="item.DesiredQty !== 0"
                      />
                      {{ item.DesiredQty }}
                    </td>
                    <td align="center"></td>
                    <td align="center"></td>
                    <td align="center"></td>
                    <td align="center"></td>
                  </tr>
                  <tr v-show="item.showDetail">
                    <td colspan="13">
                      <table
                        width="100%"
                        style="background-color: $color-background"
                      >
                        <tr v-for="(detail, dindex) in item.OrderGeoDetails">
                          <td
                            width="1%"
                            style="background-color: white; border: 0px"
                          ></td>
                          <td width="14%">
                            {{ detail.DetailName }}
                          </td>
                          <td align="center" width="6%">
                            {{ detail.AvailableQtyHome }}
                          </td>
                          <td width="10%">
                            <input
                              type="checkbox"
                              @change="
                                changeGeoDetailCount(
                                  'c',
                                  'homes',
                                  index,
                                  dindex,
                                  $event,
                                  detail.AvailableQtyHome,
                                  detail.DesiredQtyHome
                                )
                              "
                              :checked="
                                detail.DesiredQtyHome > 0 &&
                                detail.AvailableQtyHome !== 0
                              "
                              :disabled="detail.AvailableQtyHome === 0"
                            />
                            <b-input
                              :max="detail.AvailableQtyHome"
                              style="width: 60px; display: inline"
                              @change="
                                changeGeoDetailCount(
                                  't',
                                  'homes',
                                  index,
                                  dindex,
                                  $event,
                                  detail.AvailableQtyHome,
                                  detail.DesiredQtyHome
                                )
                              "
                              :value="detail.DesiredQtyHome"
                              :disabled="detail.AvailableQtyHome === 0"
                            ></b-input>
                          </td>
                          <td align="center" width="6%">
                            {{ detail.AvailableQtyApt }}
                          </td>
                          <td width="10%">
                            <input
                              type="checkbox"
                              @change="
                                changeGeoDetailCount(
                                  'c',
                                  'apts',
                                  index,
                                  dindex,
                                  $event,
                                  detail.AvailableQtyApt,
                                  detail.DesiredQtyApt
                                )
                              "
                              :checked="
                                detail.DesiredQtyApt > 0 &&
                                detail.AvailableQtyApt !== 0
                              "
                              :disabled="detail.AvailableQtyApt === 0"
                            />
                            <b-input
                              :max="detail.AvailableQtyHome"
                              style="width: 60px; display: inline"
                              @change="
                                changeGeoDetailCount(
                                  't',
                                  'apts',
                                  index,
                                  dindex,
                                  $event,
                                  detail.AvailableQtyApt,
                                  detail.DesiredQtyApt
                                )
                              "
                              :value="detail.DesiredQtyApt"
                              :disabled="detail.AvailableQtyApt === 0"
                            ></b-input>
                          </td>
                          <td align="center" width="6%">
                            {{ detail.AvailableQtyBuss }}
                          </td>
                          <td width="10%">
                            <input
                              type="checkbox"
                              @change="
                                changeGeoDetailCount(
                                  'c',
                                  'business',
                                  index,
                                  dindex,
                                  $event,
                                  detail.AvailableQtyBuss,
                                  detail.DesiredQtyBuss
                                )
                              "
                              :checked="
                                detail.DesiredQtyBuss > 0 &&
                                detail.AvailableQtyBuss !== 0
                              "
                              :disabled="detail.AvailableQtyBuss === 0"
                            />
                            <b-input
                              :max="detail.AvailableQtyHome"
                              style="width: 60px; display: inline"
                              @change="
                                changeGeoDetailCount(
                                  't',
                                  'business',
                                  index,
                                  dindex,
                                  $event,
                                  detail.AvailableQtyBuss,
                                  detail.DesiredQtyBuss
                                )
                              "
                              :value="detail.DesiredQtyBuss"
                              :disabled="detail.AvailableQtyBuss === 0"
                            ></b-input>
                          </td>
                          <td align="center" width="6%">
                            {{ detail.AvailableQty }}
                          </td>
                          <td width="10%">
                            <input
                              type="checkbox"
                              @change="
                                changeGeoDetailCount(
                                  'c',
                                  'total',
                                  index,
                                  dindex,
                                  $event,
                                  detail.AvailableQty,
                                  detail.DesiredQty
                                )
                              "
                              :checked="detail.DesiredQty !== 0"
                            />
                            {{ detail.DesiredQty }}
                          </td>
                          <td align="left" width="6%">
                            <span>${{ detail.Income }}</span>
                          </td>
                          <td align="left" width="9%">
                            <span>${{ detail.HomeValue }}</span>
                          </td>
                          <td align="left" width="5%">
                            <span>{{ detail.MedianAge }}</span>
                          </td>
                          <td align="left" width="5%">
                            <span>{{ detail.PHWC }}</span>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </b-col>
        </b-row>
    </b-container>
  </div>
</template>

<script>
import utils from "@/assets/utils/index";
export default {
  components: {},
  data() {
    return {
      sort: "descending",
      sortFild: "",
    };
  },
  computed: {
    geos() {
      if (this.sortFild !== "") {
        let templGeos = JSON.parse(
          JSON.stringify(this.$store.getters["order/geoItems"])
        );
        for (var item in templGeos) {
          let xx = this.stableSort(
            templGeos[item].OrderGeoDetails,
            this.getComparator(this.sort, this.sortFild)
          );
          templGeos[item].OrderGeoDetails = xx;
        }
        return templGeos;
      } else {
        return this.$store.getters["order/geoItems"];
      }
    },
    order() {
      return this.$store.state.order;
    },
  },
  methods: {
    tiggerShow(index) {
      this.$store.commit("order/tiggerGeoShowDetail", index);
    },
    changeGeoCount(type, index, e) {
      this.$store.dispatch("order/changeGeoCount", {
        type: type,
        index: index,
        checked: e.target.checked,
      });
    },
    changeGeoDetailCount(t, type, rowIndex, index, e, aq, dq) {
      // t: checkbox/input; type: home/apts/business; rowIndex: row index; index: index; e: input or checkbox value, aq:AvailableQty  dq: DesiredQty
      if (t === "c") {
        if (e.target.checked) {
          dq = aq;
        } else {
          dq = 0;
        }
      } else {
        if (Number(e) > aq) {
          e = aq;
          dq = aq;
        } else {
          dq = Number(e);
        }
      }
      this.$store.dispatch("order/changeGeoDetailCount", {
        type: type,
        rowIndex: rowIndex,
        index: index,
        count: dq,
      });
    },
    exportCountResult() {
      this.$http
        .post(
          "PlaceOrder.aspx/GenerateCISReportExcel",
          {
            order: this.$store.state.order,
          },
          {
            errorType: "custom",
          }
        )
        .then(
          (resp) => {
            if (resp.body.d.ResultFlag) {
              window.location = `${utils.getRootPath().replace("/r/", "")}${
                resp.body.d.DataSource
              }`;
            } else {
              console.log(resp.body.d);
            }
          },
          (resp) => {
            console.log(resp);
          }
        );
    },
    descendingComparator(a, b, orderBy) {
      if (b[orderBy] < a[orderBy]) {
        return -1;
      }
      if (b[orderBy] > a[orderBy]) {
        return 1;
      }
      return 0;
    },
    getComparator(order, orderBy) {
      return order === "descending"
        ? (a, b) => this.descendingComparator(a, b, orderBy)
        : (a, b) => -this.descendingComparator(a, b, orderBy);
    },
    stableSort(array, comparator) {
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
      });
      return stabilizedThis.map((el) => el[0]);
    },
    sortClick(field) {
      if (this.sortFild === field) {
        if (this.sort === "descending") {
          this.sort = "ascending";
        } else {
          this.sortFild = "";
        }
      } else {
        this.sortFild = field;
        this.sort = "descending";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.GeographyDetail {
  /*width:100%;border-bottom-width:1px;*/
  /*border-bottom-color:Black;*/
  /*border-bottom-style:solid;*/
}

.tablehead {
  color: #ffffff;
  font-size: 11px;
  font-weight: normal;
  line-height: 14px;
  border-style: solid;
  border-color: White;
  border-width: 1px;
  background-color: #a9a8af;
}
.sorthead {
  border-style: solid;
  border-color: #a9a8af;
  border-width: 1px;
  font-size: 11px;
  font-weight: normal;
  line-height: 16px;
}
.GeographyDetail td {
  /*<!--font-weight: bold;-->*/
  /*<!--font-size: 11px;-->*/
  /*<!--border-color: $color-text-grey;-->*/
  /*<!--border-width: 1px;-->*/
  /*<!--border-style: solid;-->*/
  /*<!--text-transform: uppercase;-->*/
}
.demo-box {
  margin-left: 8px;
  margin-bottom: 0px;
  margin-top: 8px;
}
.card-margin {
  margin: 10px auto;
}
.text-style {
  text-align: center;
}
.table {
  border: 1px solid #edf1f6;
}
.table td {
  padding: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/summary/MGeoGraphies.vue